

























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CommonButton extends Vue {
  @Prop(String) public icon!: string;
  @Prop(String) public iconClass!: string;
  @Prop(Number) public iconSize!: number;
  @Prop(Number) public width!: number;
  @Prop(Number) public height!: number;
  @Prop(String) public buttonColor!: string;
  @Prop(String) public elevation!: string;
  @Prop({ type: Boolean, default: false }) public rounded!: boolean;
  @Prop({ type: Boolean, default: false }) public dark!: boolean;
  @Prop({ type: Boolean, default: false }) public outlined!: boolean;
  @Prop({ type: Boolean, default: false }) public small!: boolean;
  @Prop({ type: Boolean, default: false }) public text!: boolean;
  @Prop({ type: Boolean, default: false }) public depressed!: boolean;


  private clickHandler(e: Event) {
    return this.$emit('click', e);
  };
}
